import { UserDetails } from './userDetails';

export const AppContext = {
  userDetails: {
    activationDate: '',
    canActivate: false,
    canAlter: false,
    canDelete: false,
    canEditRetrieval: false,
    canEditWorkflow: false,
    canReAssign: false,
    canRelease: false,
    canSuspend: false,
    emailId: '',
    fullName: '',
    highestSecurityTypeName: '',
    isSystemAdmin: false,
    userId: 0,
    userName: '',
    userType: 0,
    systemId: 0,
    userRoles: {},
  } as UserDetails,
};
